var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Background, BorderSize, Foreground, Stroke } from '@front/sharedcomponents/Styles';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import '@styles/webdesktop/stylesheets/lineIconButton.scss';
export const LineIconButton = (_a) => {
    var { icon, disabled, onClick } = _a, restProps = __rest(_a, ["icon", "disabled", "onClick"]);
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            onClick();
        }
    };
    const className = [
        'line-icon-button',
        Foreground.Secondary,
        Foreground.LineIconButton,
        Background.Secondary,
        Background.LineIconButton,
        Stroke.General,
        BorderSize.Solid1
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx("button", Object.assign({ className: className, onClick: onClick, onKeyDown: handleKeyDown, disabled: disabled }, restProps, { children: _jsx(SvgIcon, { className: "line-icon-button-icon", icon: icon }) })));
};
